import React, { Component, useEffect, useState } from 'react';
import CardView from './CardsView';
import crmservices from '../../wsclient/crmservices'
import AddCard from './AddCard';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import { newGUID } from '../../utils/util';
import { getAppCfg, getCurrencyCode, setAddCardInfo } from '../../utils/common';
import { portalCfg } from '../../../portal.router.config';
import ModalConfirm from '../../components/ModalConfirm';
import { payment } from '../../wsclient/crmservices/payment';
import { connection } from '../../../portal.config';

// accountt 
// sb-zohys7237983@business.example.com
// M;SB31?x
// EJ37VS8BQHJVA
// sb-2vtnz7239030@personal.example.com
// 0pB{^r7P
// RB7JN2DTVU566
// sb-xtymq7240364@personal.example.com
// 2Oasr!Sz
// 5Z3ABHFRWGEMY

function Cards(props) {
    const [cards, setCards] = useState([]); 
    const [openAddCard, setOpenAddCard] = useState(false);
    const [message, setMessage] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [html_add_card_content, setHtmlAddCardContent] = useState(null);
    const [showFormStripe, setShowFormStripe] = useState(false);
    const [confirm, setConfirm] = useState(null);
    const [integration, setIntegration] = useState(null);
    const currency_code = getCurrencyCode();

    useEffect(()=>{
        onLoadPaymentMethods();
        getIntegrations();
    },[]);


    const onLoadPaymentMethods = async(isRefresh) =>{
        onShowLoading(true);
        let paypals = [];
        try {
            let result = await crmservices.contacts.getListPaymentMethods();
            console.log("onLoadPaymentMethods result==", result);
            if (result.code == 'OK') {
                let paymentMethods = result.data.content;
                setCards(paymentMethods);
                paypals = paymentMethods.filter(paymentMethod => paymentMethod.name === 'PayPal');
            }
        } catch (error) {
            console.log("on load payment method exception:", error);
        }
        onShowLoading(false);
        return paypals;
    }

    const setPrimaryCard = async(paymentMethodID) =>{
        onShowLoading(true);
        try {
            let result = await crmservices.contacts.setPrimaryCard(paymentMethodID);
            if (result.code == 'OK') {
                await onLoadPaymentMethods();
                showMessage(true, t('You have successfully set this card as primary'));
                if(props.fromOrder){
                    props.onCloseItem();
                }
            } else {
                showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onRemoveCard = async (card) =>{
        onShowLoading(true);
        setConfirm(null);
        try {
            let result = await crmservices.contacts.removePaymentMethod(card.id);
            //console.log(' onRemoveCard card==', card)
            if (result.code == 'OK') {
                await onLoadPaymentMethods();
                showMessage(true, t('REMOVE_CARD_SUCCESS'));
            } else {
                showMessage(true, t('FAILED_TO_REMOVE_CARD'));
            }
        } catch (ex) {
            console.log("remove card exception:", ex);
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }

    const onOpenAddCard = async() =>{
        onShowLoading(true)
        try {
            let token = newGUID();
            let responseURL = window.location.origin + portalCfg.basename + '/process_addcard/' + token;
            console.log(' onPrepareForm responseURL===', responseURL)
            let result = await crmservices.contacts.createFormToAddCard(responseURL);
            console.log(' onPrepareForm result===', result)
            if (result.code == 'OK') {
                //window.document.write(result.data);
                setAddCardInfo({token: token});
                setHtmlAddCardContent(result.data);
                setOpenAddCard(true)  
            }
        } catch (error) {
            console.log("on create form to add card exception:", error);
        }
        onShowLoading(false);
    }
    const onCloseAddCard = () =>{
        onLoadPaymentMethods();
        setOpenAddCard(false);
    }
    const showMessage = async (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }
    const confirmRemoveCard = (card) => {
        setConfirm({
            show: true,
            actionTitle: t('yes'),
            onAction: () => onRemoveCard(card),
            message: t('message_delete_card'),
        });
    }

    const getIntegrations = async () => {
        if (connection.crmConfig.isOpenStripe) {
            setIntegration({ id: connection.crmConfig.stripeIntegration })
            return;
        }
        try {
            let portalConfig = getAppCfg();
            let result = await payment.getIntegrations({
                connector: 'SOLIDGATE'
            }, portalConfig.id);
            console.log("AAAA getIntegrations result: ", result)
            if (result.code == 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) setIntegration(result.data.content[0])
            }
        } catch (error) {
            console.log("AAAA getIntegrations error: ", error)
        }
    }

    const addDebitCard = async () => {
        onShowLoading(true)
        let token = newGUID();
        let responseURL = window.location.origin + `/process_addcard/${token}`
        try {
            let result = await payment.getFormAddCard({
                integration_id: connection.crmConfig.isOpenStripe ? connection.crmConfig.stripeIntegration : integration?.id,
                device_type: 'BROWSER',
                currency_code: currency_code,
                redirect_url: responseURL
            });
            if (result.code == 'OK') {
                setAddCardInfo({ token: token });
                let data = result.data ? JSON.parse(result.data) : null;
                if (data && data.form_url) {
                    window.location.href = data.form_url;
                }
            } else {
                let mess = 'Plugin integration error.';
                if(result.data && result.data.message) {
                    mess = result.data.message;
                }
                showMessage(true, mess);
            }
        } catch (error) {
            console.log("AAAA addDebitCard error: ", error)
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false)
    }

    return (
        <div>
            <CardView
                open = {props.open}
                onCloseItem = {props.onCloseItem}
                showLoading = {showLoading} 
                showFormStripe={showFormStripe}
                cards={cards.filter(card => card.payment_method_type === 'CARD' && card.name !== 'STRIPE' && card.name !== 'FAC')}
                paypals={cards.filter(card => card.name && card.name === 'PayPal')}
                stripes={cards.filter(card => card.name && card.name === 'STRIPE')}
                facs={cards.filter(card => card.name && card.name === 'FAC')}
                onOpenAddCard = {onOpenAddCard}
                setPrimaryCard = {setPrimaryCard}
                onRemoveCard = {confirmRemoveCard}
                showMessage={showMessage}
                onRefresh={onLoadPaymentMethods}
                setShowFormStripe={setShowFormStripe}
                setOpen={props.setOpen}
                addDebitCard={addDebitCard}
            />
            {openAddCard && <AddCard
                open = {openAddCard}
                onClose = {onCloseAddCard} 
                html_add_card_content = {html_add_card_content}   />}
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={() => setConfirm({})}
                message={confirm.message}
                confirm={confirm.actionTitle}
                onAction={confirm.onAction ? () => confirm.onAction() : null}
            />}
        </div>
    );
}

export default Cards;